// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__I8CHJ","navlink":"navbar_navlink__j5VHf"};